var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoLarge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 100,
    viewBox: "0 0 178 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1817_13092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.8006 19.8964L84.752 20.0001L84.7922 19.8964H84.8006Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.535 21.6412C107.018 31.265 99.307 39.0837 89.5699 39.4663C79.2535 39.8713 70.5613 31.7779 70.1348 21.3792L107.535 21.6412Z",
    fill: "#5E514D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0226 21.6412C94.9473 21.6412 99.7503 16.7967 99.7503 10.8206C99.7503 4.84455 94.9473 0 89.0226 0C83.0979 0 78.2949 4.84455 78.2949 10.8206C78.2949 16.7967 83.0979 21.6412 89.0226 21.6412Z",
    fill: "#5E514D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9395 55.9123L60.8085 38.966L117.793 39.413L127.061 55.9263L50.9395 55.9123Z",
    fill: "#5E514D"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.00195312 99.4545V78.7105H3.20868L12.3805 93.8534H10.7008L19.7232 78.7105H22.9299L22.9884 99.4545H19.2423V84.4304H19.9928L12.3805 97.1133H10.6131L2.81881 84.4304H3.71877V99.4545H0.00195312Z",
    fill: "#5E514D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2817 99.4545V91.2456L42.1817 93.5868L33.0391 78.7105H37.175L44.5501 90.7124H42.2109L49.5568 78.7105H53.3938L44.2805 93.5868L45.1512 91.2456V99.4545H41.2849H41.2817Z",
    fill: "#5E514D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3916 99.4545V81.9703H60.4355V78.7105H78.2431V81.9703H71.2871V99.4545H67.3916Z",
    fill: "#5E514D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6738 99.4545V78.7105H92.5693V99.4545H88.6738Z",
    fill: "#5E514D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M105.729 99.4545V78.7105H114.361C116.219 78.7105 117.811 79.0027 119.143 79.584C120.472 80.1686 121.496 81.01 122.217 82.118C122.935 83.2261 123.296 84.5493 123.296 86.0876C123.296 87.626 122.935 88.9171 122.217 90.0155C121.499 91.1107 120.472 91.9618 119.143 92.5655C117.815 93.1693 116.219 93.468 114.361 93.468H107.915L109.624 91.692V99.4545H105.729ZM109.624 92.1031L107.915 90.2082H114.179C115.898 90.2082 117.191 89.8485 118.062 89.1259C118.929 88.4032 119.364 87.3916 119.364 86.0876C119.364 84.7837 118.929 83.772 118.062 83.0494C117.191 82.3268 115.898 81.9671 114.179 81.9671H107.915L109.624 80.0722V92.1031Z",
    fill: "#5E514D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M138.58 96.1947H150.42V99.4545H134.682V78.7105H150.001V81.9703H138.58V96.1947ZM138.281 87.3338H148.714V90.5037H138.281V87.3338Z",
    fill: "#5E514D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M166.16 96.1947H178V99.4545H162.262V78.7105H177.581V81.9703H166.16V96.1947ZM165.862 87.3338H176.294V90.5037H165.862V87.3338Z",
    fill: "#5E514D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1817_13092"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76.122,
    height: 55.9263,
    fill: "white",
    transform: "translate(50.9395)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLarge);
export default __webpack_public_path__ + "static/media/logoLarge.4c7371aad9664117828dad479f39badd.svg";
export { ForwardRef as ReactComponent };